import gql from 'graphql-tag'

export default gql`
query products($group: String!) {
  products(
    sort: _ID_DESC
    filter: {
      group: $group
    }
  ) {
    _id
    group
    name
    size
    color
    checkInItemCount
    sku
    shirtId
    stock {
      race
      shop
      inbox
      total
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/productsStock.js